import { FieldValues, UseFormRegister } from 'react-hook-form';
import SingleSelect from '../../../atoms/SingleSelect';

// コンボボックスの表示データ
const accessItems = [
  { name: '〇', value: '0' },
  { name: '△', value: '1' },
  { name: '×', value: '2' },
];

const authorityItems = [
  { name: '*0', value: '0' },
  { name: '*1', value: '1' },
  { name: '*2', value: '2' },
  // { name: '*3', value: '3' },
];

//
// アクセス制限と権限設定用
//
interface SelectGroupAccessAndAuthorityProps<T> {
  nameAccess: string;
  nameAuthority: string;
  register: UseFormRegister<FieldValues>;
}

//
// アクセス制限と権限設定のコンボボックス
//
export function SelectGroupAccessAndAuthority<T>({
  nameAccess,
  nameAuthority,
  register,
}: SelectGroupAccessAndAuthorityProps<T>) {
  return (
    <>
      <td>
        <span>
          <SingleSelect
            id={`${nameAccess}`}
            name={`${nameAccess}`}
            allowEmpty={false}
            options={Array.from(accessItems, (x) => x)}
            register={register}
            getValue={(x) => x.value}
            getLabel={(x) => x.name}
          />
        </span>
      </td>
      <td>
        <span>
          <SingleSelect
            id={`${nameAuthority}`}
            name={`${nameAuthority}`}
            allowEmpty={false}
            options={Array.from(authorityItems, (x) => x)}
            register={register}
            getValue={(x) => x.value}
            getLabel={(x) => x.name}
          />
        </span>
      </td>
    </>
  );
}
